<template>
  <div class="departManage-container div-layout">
    <div class="departManage-main flex">
      <div class="departManage-right flex_1">
        <module-title title="部门管理">
          <div class="fr">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              @click="handleOpr('add')"
            >
              新建部门
            </el-button>
          </div>
        </module-title>
        <div class="departManage-search">
          <el-form ref="departManage-search-form" :model="searchForm" :inline="true" label-position="right" label-width="100px">
            <div>
              <el-form-item label="部门名称：" prop="name">
                <el-input
                  v-model="searchForm.name"
                  name="name"
                  auto-complete="off"
                  size="medium"
                  placeholder="请输入部门名称"
                  class="edit-form-input"
                  clearable
                />
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择" class="edit-form-input">
                  <el-option label="全部" value="" />
                  <el-option
                    v-for="(val, key) in stateOptions"
                    :key="key"
                    :label="val"
                    :value="key"
                  />
                </el-select>
              </el-form-item>
              <el-form-item class="search-btns">
                <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
                  查询
                </el-button>
              </el-form-item>
            </div>
          </el-form>
          <el-table
            v-loading="listLoading"
            :data="departManageList"
            fit
            highlight-current-row
            element-loading-text="Loading"
          >
            <el-table-column label="序号" align="center" type="index" width="55" />
            <el-table-column label="部门名称" prop="name" width="200px" align="center" />
            <el-table-column label="描述" prop="remark" align="center" />
            <el-table-column label="成员数量" prop="number" align="center" />
            <el-table-column label="状态" align="center" width="150px">
              <template slot-scope="scope">
                已{{ stateOptions[scope.row.status] }}
              </template>
            </el-table-column>
            <el-table-column label="最后修改时间" width="180px" align="center">
              <template slot-scope="scope">
                {{ scope.row.updateDate ? scope.row.updateDate : scope.row.createDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" prop="op" align="center" width="300px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleOpr('edit',scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="Number(scope.row.status)===1"
                  type="warning"
                  size="small"
                  icon="el-icon-warning-outline"
                  @click="batchOpreate('forbidden',[scope.row])"
                >
                  禁用
                </el-button>
                <el-button
                  v-else
                  type="success"
                  icon="el-icon-success"
                  size="small"
                  @click="batchOpreate('enable',[scope.row])"
                >
                  启用
                </el-button>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-info"
                  @click="handleOpr('memberMgmt',scope.row)"
                >
                  成员管理
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :total="pageObj.total"
            :page.sync="pageObj.currentPage"
            :limit.sync="pageObj.pageSize"
            @pagination="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <!-- 新建/编辑部门-->
    <add-depart
      v-if="dialogViewAddVisible"
      :add-obj="addObj"
      :visible.sync="dialogViewAddVisible"
      :opr-type="oprType"
      :btn-loading="loadingObj.addOrEdit_btn"
      @handleAddComfirm="handleAddComfirm"
    />
  </div>
</template>

<script>

import AddDepart from './addDepart';
import {
  getDepartList,
  addDepart,
  editDepart,
  batchDepart
} from '@/api/systemManage/permissionMgmt/departManage';
// import departManageMember from './departManageMember';

export default {
  name: 'DepartManage',
  components: {
    AddDepart
  },
  data() {
    return {
      searchForm: {
        status: ''
      },
      departManageList: [], // 列表
      // 翻页设置
      pageObj: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // 用于防重复提交
      loadingObj: {
        addOrEdit_btn: false // 编辑或新增
      },
      listLoading: false,
      // 新增/编辑
      dialogViewAddVisible: false, // 新增/编辑弹出框标识
      oprType: '', // 操作标识 add：新增，edit：编辑
      addObj: {} // 编辑/新增保存对象
    };
  },
  computed: {
    stateOptions() {
      const stateList = {
        '1': '启用',
        '0': '禁用'
      };
      return stateList;
    }
  },
  mounted() {
    // 查询部门列表
    this.queryDepartList();
  },
  methods: {
    // pageSize 改变时会触发
    handleSizeChange(obj) {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = obj.limit;
      this.queryDepartList();
    },
    // currentPage 改变时会触发
    handleCurrentChange(obj) {
      this.pageObj.currentPage = obj.page;
      this.pageObj.pageSize = obj.limit;
      this.queryDepartList();
    },
    // 条件查询
    handleSearchFilter() {
      this.pageObj.currentPage = 1;
      this.pageObj.pageSize = 10;
      this.queryDepartList();
    },

    // 点击新增与编辑按钮操作 type:操作标识 row：部门对象
    handleOpr(type, row) {
      this.oprType = type;
      this.addObj = row ? { ...row } : { status: 1 };
      switch (type) {
        case 'edit':
        case 'add':
          // 编辑/添加
          this.dialogViewAddVisible = true;
          break;
        case 'batchForbidden':
        case 'forbidden':
          // 禁用
          var comfTip = '确定要禁用该部门吗?';
          if (type === 'batchForbidden') {
            comfTip = `当前已选${this.multipleSelection.length}个部门，确定要批量禁用吗？`;
            this.oprType = 'forbidden';
          }
          this.$confirm(comfTip, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.addObj.status = 0;
            this.callInterfaceFn();
          }).catch(() => {});
          break;
        case 'enable':
          // 启用
          this.addObj.status = 1;
          this.callInterfaceFn();
          break;
        case 'memberMgmt':
          // 成员管理
          this.$router.push({ name: 'LeaguerManage', query: { orgCode: this.addObj.code }});
          break;
      }
    },
    // 更多下拉菜单点击事件
    handleCommand(command) {
      this.handleOpr(command.type, command.row);
    },
    // 新增修改确认
    handleAddComfirm(param) {
      this.addObj = { ...param };
      this.callInterfaceFn();
    },
    // 批量操作（批量启用，批量禁用）
    batchOpreate(type, row) {
      const convertId = function(op) {
        const opIds = [];
        op.map(item => {
          opIds.push(item.id);
        });
        return opIds;
      };
      const ids = convertId(row);
      // row.id = ids.join();
      row.id = ids;
      this.handleOpr(type, row);
    },

    // 获取默认勾选
    getDefaultChecked(data) {
      const checked = [];
      function filterChildren(children) {
        children.map(item => {
          // 去掉父级选中，父级选中以子级来判断
          if (item.choose && item.pid)checked.push(item.id);
          if (item.childPermissionGroupList.length > 0) {
            filterChildren(item.childPermissionGroupList);
          }
        });
      }
      filterChildren(data);
      return checked;
    },
    // 查询部门列表
    queryDepartList() {
      this.listLoading = true;
      getDepartList({
        pageNum: this.pageObj.currentPage,
        pageSize: this.pageObj.pageSize,
        ...this.searchForm // 搜索条件
      }).then(response => {
        this.listLoading = false;
        const data = response.data;
        if (data) {
          data.list && data.list.map((item) => {
            item.more = false;
          });
          this.departManageList = data.list;
          this.pageObj.total = data.total;
        }
      }).catch(error => {
        this.listLoading = false;
        console.log(error);
      });
    },
    // 新增/编辑调用接口
    callInterfaceFn() {
      const interfaceName = this.mapSet('interfaceName');

      // 防重复提交
      if (this.oprType === 'add' || this.oprType === 'edit') {
        if (this.loadingObj.addOrEdit_btn) {
          return;
        }
        this.loadingObj.addOrEdit_btn = true;
      }

      interfaceName(this.mapSet('param')).then(response => {
        this.$notify.success({
          title: 'Success',
          message: this.mapSet('succTip'),
          showClose: false,
          duration: 2000
        });
        // 更新列表
        this.queryDepartList();
        this.loadingObj.addOrEdit_btn = false;
        this.dialogViewAddVisible = false;
      }).catch(() => {
        this.loadingObj.addOrEdit_btn = false;
      });
    },
    // 映射，用于操作提示与接口调用
    mapSet(mapName) {
      const _addObj = this.addObj;
      const mapObj = {
        'add': {
          succTip: '新增成功',
          interfaceName: addDepart,
          param: {
            name: _addObj.name, // 部门名称
            remark: _addObj.remark, // 状态
            status: _addObj.status
          }
        },
        'edit': {
          succTip: '编辑成功',
          interfaceName: editDepart,
          param: {
            name: _addObj.name, // 部门名称
            remark: _addObj.remark, // 状态
            id: _addObj.id,
            status: _addObj.status
          }
        },
        'enable': {
          succTip: '启用成功',
          interfaceName: batchDepart,
          param: {
            ids: _addObj.id,
            status: 1
          }
        },
        'forbidden': {
          succTip: '禁用成功',
          interfaceName: batchDepart,
          param: {
            ids: _addObj.id,
            status: 0
          }
        }
      };
      return mapObj[this.oprType][mapName];
    }
  }

};
</script>
<style lang="scss" scoped>
.departManage-container {
  .departManage-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .departManage-left {
      .module-title {
        margin-bottom: 30px;
      }
    }
    .departManage-right {
      .departManage-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
      .edit-form-item {
        margin-left: 5px;
      }
      .table-page {
        margin-top: 20px;
        float: right;
      }
      .handle-span {
        display: inline-block;
        margin-left: 10px;
        color: #1890ff;
        cursor: pointer;
      }
      .search-btns {
        margin-left:20px;
      }
      .check-tip {
        display:inline;
        margin-left: 20px;
      }
    }
  }
  .fr {
    float: right;
  }
  .moreBtn{
    margin-left: 10px;
  }
}
</style>

